export default __webpack_public_path__ + "static/media/jt.aad31907.png";